<template>
  <div class="generic-building">
    <SensorInfo
      v-if="showSensorEditing"
      @close="showSensorEditing = false"
      @delete-sensor="deleteSensor"
      @add-sensor="insertNewSensor"
      @update-sensor="updateSensor"
      @reset-sensor-stats="resetSensorStats"
      :sensor="this.selectedSensor"
      :newType="this.actualType"
      :generic="true"
    />
    <transition name="settings">
      <Groups v-if="showFDDGroups" :sensorType="actualType" :structure="this.selectedStructure" @close-groups="showFDDGroups = false" />
    </transition>
    <!-- Tips in overlay -->
    <div id="help-tip" class="over-info">
      <h2>{{ $t("message.deviceselect") }}</h2>
      <img class="info-svg" @click="isInfoVisible = !isInfoVisible" src="../../../public/assets/icons/info.svg" alt />
      <!-- Modal Info Selezione Deck -->
      <ModalInfo v-if="isInfoVisible" class="modal-info" id="info-deck" @close="isInfoVisible = false">
        <template v-slot:header>
          <h2>{{ $t("message.deviceselect") }}</h2>
        </template>
        <template v-slot:body class="modal-temp">
          <p>{{ $t("message.deviceselectinfo") }}</p>
        </template>
      </ModalInfo>
      <p>{{ $t("message.bridgescroll") }}</p>
      <SensorToggle
        v-if="tempSensors"
        id="sensortoggle2"
        :sensors="tempSensors"
        :selectedSensor="selectedSensor"
        :showAll="editable"
        @type-selected="this.typeSelected"
      />
      <div class="extra-control" v-if="editable">
        <button @click="showFDDGroups = true" :disabled="(this.actualType !== 'deck' && this.actualType !== 'accelerometer') || !(this.validSensors.length > 0)">FDD</button>
      </div>
    </div>

    <div id="drop-area" class="dropp">
      <img v-if="selectedStructure.images && selectedStructure.images.length > 0" class="map-img" :src="`data:image/png;base64,${selectedStructure.images[0].image.buffer}`" />
      <div v-else class="overlay"><h1>Immagine Non Trovata</h1></div>
      <div
        :class="[sensor.position && sensor.position.y && sensor.position.x ? 'dropped' : '', checkIfSelected(sensor) ? 'selected' : '', 'sensor']"
        v-for="(sensor, index) in tempSensors"
        :key="sensor.eui"
        :id="sensor.eui"
        v-show="sensor.type === actualType && (checkIfAlreadyPositioned(sensor) || editMode)"
        :style="{
          top: sensor.position && sensor.position.y ? sensor.position.y + '%' : 30 * (index % 10) + 'px',
          left: sensor.position && sensor.position.x ? sensor.position.x + '%' : parseInt(index / 10) * 60 + 20 + 'px',
        }"
        @click="selectSensor(sensor)"
      >
        <span class="sensor-dot" :style="{ backgroundColor: getSensorColor(sensor) }"></span>
        <p>
          {{ sensor.eui.substr(sensor.eui.length - 5) }}
        </p>
      </div>
    </div>
    <div id="control-area" v-if="editable">
      <button :class="{ active: editMode }" id="edit-btn" v-if="editable" @click="editMode = !editMode">editMode</button>
      <button :disabled="!editMode" @click="addSensor">{{ selectedSensor ? "Modifica Sensore" : "Aggiungi Sensore" }}</button>
      <button :disabled="!editMode" @click="saveSensorsPosition">Salva</button>
      <button :disabled="!editMode" @click="undo">Annulla</button>
      <button :disabled="!editMode" @click="deleteImage" v-if="selectedStructure.images && selectedStructure.images[0]">
        {{ selectedStructure.images && selectedStructure.images[0] ? "Elimina Immagine" : "Aggiungi immagine" }}
      </button>
      <!-- Img Upload -->
      <image-uploader
        class="image-uploader"
        v-if="!(selectedStructure.images && selectedStructure.images[0])"
        :preview="false"
        :className="['fileinput', { 'fileinput--loaded': selectedStructure.images ? selectedStructure.images[0] : null }]"
        capture="environment"
        :debug="1"
        doNotResize="gif"
        :autoRotate="true"
        outputFormat="file"
        @input="setImage"
      >
        <label for="fileInput" slot="upload-label">
          <figure>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
              <path
                class="path1"
                d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
              ></path>
            </svg>
          </figure>
          <span class="upload-caption">{{ selectedStructure.images && selectedStructure.images[0] ? "Replace" : "Upload" }}</span>
        </label>
      </image-uploader>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import SensorInfo from "../admin/modal/SensorInfo";
import Groups from "../admin/modal/Groups";
import SensorToggle from "../ui/SensorToggle";
import ModalInfo from "../ui/ModalInfo.vue";

export default {
  name: "image-building",
  components: {
    SensorToggle,
    ModalInfo,
    Groups,
    SensorInfo,
  },
  props: {
    selectedStructure: Object,
    selectedSensorFromParent: Object,
    editable: Boolean,
  },
  data() {
    return {
      showSensorEditing: false,
      editMode: true,
      isInfoVisible: false,
      selectedSensor: null,
      tempSensors: null,
      actualType: null,
      types: ["deck", "tiltmeter", "accelerometer", "crackmeter"],
      image: null,
      maxFileSize: 256, //kB
      showFDDGroups: false,
    };
  },
  computed: {
    validSensors: function () {
      let type = this.actualType;
      return this.tempSensors.filter(function (el) {
        return el.type === type;
      });
    },
    isLambro() {
      return this.tempSensors ? this.tempSensors.some((sn) => sn.eui === "C0EE400001015144"): false;
    },
  },
  methods: {
    /* Aggiunta Immagine */
    setImage: function (output) {
      if (output.size / 1024 <= this.maxFileSize) {
        this.image = output;
        this.$emit("add-image", output);
      } else {
        window.alert("Immagine troppo grando (max" + this.maxFileSize + "kB)");
      }
    },
    undo() {
      this.tempSensors = JSON.parse(JSON.stringify(this.selectedStructure.sensors));
    },
    selectSensor(sensor) {
      if (this.checkIfAlreadyPositioned(sensor)) {
        if (this.editable && this.selectedSensor) {
          this.selectedSensor = null;
        } else {
          this.selectedSensor = sensor;
          this.$emit("sensor-selected", this.selectedSensor);
        }
      }
    },
    deleteImage() {
      if (confirm("Eliminare l'immagine?")) {
        this.$emit("delete-image", this.selectedStructure.images[0]._id);
      }
    },
    addSensor() {
      this.showSensorEditing = !this.showSensorEditing;
    },
    deleteSensor(sensor) {
      this.$emit("delete-sensor", sensor);
    },
    insertNewSensor(sensor) {
      this.$emit("add-sensor", sensor);
    },
    updateSensor(eui, sensor) {
      let sensorObject = {};
      sensorObject.eui = eui;
      sensorObject.sensorInfo = sensor;
      this.$emit("update-sensor", sensorObject);
    },
    resetSensorStats(sensor) {
      this.$emit("reset-stats-sensor", sensor);
    },
    checkIfAlreadyPositioned(sensor) {
      return sensor.position && sensor.position.x && sensor.position.y;
    },
    checkIfSelected(sensor) {
      return this.selectedSensor && sensor.eui === this.selectedSensor.eui;
    },
    checkIfOnline(sensor) {
      const maxOffset = sensor.type === "analog-node" ? 65 : 35; // Massimo delta ammissibile in minuti
      const diff = Math.abs(new Date() - new Date(sensor.stats.lastTX)); // Differenza in ms. dall'ultima trasmissione
      return Math.floor(diff / 1000 / 60) <= maxOffset;
    },
    getSensorColor(sensor) {
      let color;
      if (this.checkIfOnline(sensor)) {
        color = "green";
      } else {
        color = "red";
      }
      return color;
    },
    typeSelected(type) {
      // Se viene selezionato un tipo ed è diverso da quello del sensore attualmente selezionato, seleziono un nuovo sensore
      this.actualType = type;
      if (!this.selectedSensor || type != this.selectedSensor.type) {
        let foundSensor = this.tempSensors.find((s) => s.type === type);
        if (foundSensor) {
          this.selectSensor(foundSensor);
        } else {
          this.selectedSensor = null;
        }
      }
    },
    setDroppedProps(eui, x, y) {
      for (let i = 0; i < this.tempSensors.length; i++) {
        if (this.tempSensors[i].eui === eui) {
          this.tempSensors[i].position = {};
          this.tempSensors[i].position.x = parseFloat(x);
          this.tempSensors[i].position.y = parseFloat(y);
        }
      }
    },
    saveSensorsPosition() {
      const newPositions = this.tempSensors
        .filter((s) => s.position && s.position.x && s.position.y)
        .map((s) => ({
          eui: s.eui,
          position: {
            ...s.position,
            x: parseFloat(s.position.x),
            y: parseFloat(s.position.y),
          },
        }));
      if (this.tempSensors.length > 0) {
        this.$emit("update-sensor-position", newPositions);
      }
    },
    handleDragAndDrop() {
      var vm = this;
      $(".sensor").draggable({
        cursor: "crosshair",
        revert: "invalid",
        containment: "#drop-area",
        stop: function () {
          var l = parseFloat(100 * parseFloat($(this).position().left / parseFloat($(this).parent().width() - 10))) + "%";
          var t = parseFloat(100 * parseFloat($(this).position().top / parseFloat($(this).parent().height()))) + "%";
          /* var l = (parseFloat($(this).position().left)) + "px" ;
          var t = (parseFloat($(this).position().top)) + "px" ; */
          $(this).css("left", l);
          $(this).css("top", t);
          vm.setDroppedProps($(this)[0].id, l, t);
        },
        snapMode: "both",
        snap: "#drop-area",
        grid: [5, 5],
        snapTolerance: 1,
      }),
        $("#drop-area").droppable({
          accept: ".sensor",
          drop: function (event, ui) {
            var dropped = ui.draggable;
            /* var left = ui.position.left, offsetWidth = left - $('#origin').width() */
            event, ui;
            //Do not permit to be more close than 80 px of the left border
            $(this).removeClass("border").removeClass("over");
            $(dropped).addClass("dropped");
          },
          over: function (event, elem) {
            elem, event;
            //var position = elem.draggable.position()
            $(this).addClass("over");
            /* console.log('over') */

            //$( "#ciao1" ).draggable( "option", "containment", "#drop-area" );
          },
          out: function (event, elem) {
            elem, event;
            $(this).removeClass("over");
            $(elem.draggable).removeClass("dropped");
            //$( "#ciao1" ).draggable( "option", "containment", "#origin" );
          },
        });
    },
  },
  beforeMount() {
    this.tempSensors = JSON.parse(JSON.stringify(this.selectedStructure.sensors));
  },
  async mounted() {
    if (this.editable) {
      this.handleDragAndDrop();
    }
    for (let i = 0; i < this.types.length; i++) {
      let foundSensor = this.tempSensors.find((s) => s.type === this.types[i]);
      if (foundSensor) {
        this.selectedSensor = foundSensor;
        break;
      }
    }
    this.$emit("sensor-selected", this.selectedSensor);
  },
  watch: {
    editMode: function (newValue) {
      $(".sensor").draggable({ disabled: Boolean(!newValue) });
    },
    selectedStructure: function (newValue) {
      this.tempSensors = JSON.parse(JSON.stringify(newValue.sensors));
      if (this.editable) {
        this.handleDragAndDrop();
      }
      this.selectedSensor = null;
      for (let i = 0; i < this.types.length; i++) {
        let foundSensor = this.tempSensors.find((s) => s.type === this.types[i]);
        if (foundSensor) {
          this.selectedSensor = foundSensor;
          break;
        }
      }
    },
  },
};
</script>
<style scoped>
button {
  cursor: pointer;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  color: white;
  font-weight: 600;
  border-radius: 5px;
  outline: none;
  height: fit-content;
  padding: 20px;
}
button:disabled {
  background-color: grey;
}
button.active {
  background-color: rgba(21, 146, 230, 1);
}
.generic-building {
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  color: white;
  display: grid;
  grid-template-rows: auto;
  position: relative;
  grid-template-columns: 10fr min-content;
  background-color: rgb(45, 48, 65);
  /*   -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
    box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75); */
  /* margin-top: 40px; */
  margin-bottom: 20px;
}

.sensor {
  background-color: green;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: fit-content; */
  position: absolute;
  cursor: pointer;
  width: 60px;
  font-size: 0.8em;
  font-weight: 700;
  cursor: pointer;
  /* text-align: center; */
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  border-radius: 20px;
  transition: transform 0.1s linear;
  box-sizing: border-box;
}
.sensor-dot {
  position: absolute;
  left: 0;
  top: calc(25% - 6px);
  /* left: 12px; */
  height: 12px;
  width: 12px;
  /* padding: 7px; */
  margin: 4px;
  background-color: unset;
  border-radius: 12px;
  display: inline-block;
  border: solid 2px white;
  z-index: 12;
  /*   display:block;
  text-align:center; 
  margin:0 auto; */
}
p {
  margin: 0;
}
.image-uploader {
  display: grid;
}
#drop-area {
  position: relative;
  /*  margin-top: 180px; */
  grid-row: 2;
  grid-column: 1;
  /* max-height: 500px; */
  /* overflow-y: scroll; */
  width: 100%;
  height: fit-content;
  overflow-y: scroll;
  display: grid;
  /* % */
  /* padding: 20px; */
  box-sizing: border-box;
  margin-bottom: 60px;
}
#control-area {
  width: 200px;
  height: fit-content;
  row-gap: 40px;
  grid-row: 1/3;
  grid-column: 2;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  padding: 40px;
  align-self: center;
  box-sizing: border-box;
}

/* #edit-btn{
  position: absolute;
  width: 120px;
  height: 60px;
  top: 40px;
  right: 200px;
  text-align: center;
} */
.overlay {
  background-color: rgb(14, 15, 19) !important;
  z-index: 12;
  border-radius: 10px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px;
  box-sizing: border-box;
}
.over {
  background-color: rgb(14, 15, 19) !important;
}
.dropped {
  width: 30px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  background-color: green !important;
  transition: width 0.4s ease, height 0.4s ease !important;
  -webkit-transition: width 0.4s ease, height 0.4s ease !important;
  border: solid 2px white;
  border-top-left-radius: 2px;
  z-index: 2;
}
.dropped:hover {
  /* transition-delay: 0.5s; */
  width: 70px;
  height: 30px;
  z-index: 12;
}
.dropped > p {
  visibility: hidden;
  position: absolute;
  right: 5px;
  opacity: 0;
  transition: visibility 0s, opacity 0.8s ease;
  font-size: 14px;
}
.dropped:hover > p {
  visibility: visible;
  opacity: 1;
}
.selected {
  background-color: rgb(24, 135, 222) !important;
}
.map-img {
  position: relative;
  /* height: fit-content; */
  left: 0;
  /* top: 0; */
  width: 100%;
  /* justify-self: center; */
}
.total-overlay {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
.modal-info {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(91, 96, 118);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-size: 0.9em;
}

#help-tip {
  /* position: absolute;
  top: 30px;
  left: 85px; */
  text-align: left;
  justify-content: left;
  display: grid;
  height: fit-content;
  padding: 60px;
}
#sensortoggle2 {
  margin-top: 20px;
  margin-bottom: 20px;
  grid-row: 3;
}
.extra-control {
  display: flex;
  grid-row: 3;
  align-items: center;
  height: 60px;
  align-self: center;
  margin-left: 30px;
}
.extra-control button {
  cursor: pointer;
  color: white;
  padding: 2px 20px;
  outline: none;
  background-color: rgb(80, 84, 105);
  border: solid 2px white;
  font-weight: 800;
  font-size: 1.2em;
  border-radius: 10px;
}
button:disabled {
  background-color: grey;
  cursor: default;
}
#info-deck {
  position: absolute;
  top: -90px;
  left: 460px;
  max-width: 500px;
}

@media all and (max-width: 1799px) and (min-width: 300px) {
  /* #help-tip {
    left: 30px;
  } */

  /* #sensortoggle2 {
    position: absolute;
    top: 100px;
    left: 30px;
    width: 600px;
  } */
}

/* .over-info {
  text-align: left;
  display: grid;
} */
.over-info > h2 {
  grid-row: 1;
  grid-column: 1;
  font-size: 1.2em;
  color: white;
  margin: 0;
}
.over-info > p {
  grid-column: 1;
  grid-row: 2;
  margin: 0;
}
.over-info > img {
  justify-self: end;
  grid-column: 1;
  grid-row: 1;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 0.6em;
}
::-webkit-scrollbar-thumb {
  background-color: white;
  border-radius: 5px;
  height: 40px;
  /* outline: 6px solid slategrey; */
}
::-webkit-scrollbar-track {
  margin-top: 70px;
  margin-bottom: 70px;
}
</style>
